// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchBar_wrapper__RdYGe","searchText":"SearchBar_searchText__9BYud"};